import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';

import MainData from '../../components/MainData';
import Passport from '../../components/Passport/Passport';
import Message from '@mos-front-components/public/es/components/Message';
import { getPermittedDocuments } from '../../helpers/getPermittedDocuments';
import { CITIZENSHIP_TYPES } from '../../constants/citizenship';

import {
  changeMainData,
  blurMainData,
  submitMainData
} from '../../store/mainData/actions';
import {
  changePassportData,
  changeDocumentType,
  blurPassportData
} from '../../store/passport/actions';
import { saveDraft } from '../../store/draft/actions';
import {
  stepApplicantStructuredSelector,
  stepApplicantStructuredSelectorPropTypes
} from './stepApplicantStructuredSelector';

import numberMask from './numberMask';
import { APPLICANT_TYPES } from '../../constants/applicant';
import { sendCMAAppealBusinessError } from '../../helpers/CMAStats';

import './StepApplicant.pcss';

class StepApplicant extends PureComponent {
  componentDidMount() {
    const { underFourteen, applicantType } = this.props;

    if (underFourteen && applicantType === APPLICANT_TYPES.parent) {
      sendCMAAppealBusinessError({ stage: 'step' });
    }
  }

  renderMainData = () => {
    const {
      mainDataValues,
      mainDataBlur,
      mainDataErrors,
      mainDataValid,
      mainDataEditableFields,
      saveDraft
    } = this.props;
    const props = {};

    if (!mainDataValues) {
      return false;
    }

    if (mainDataBlur) {
      props.errors = mainDataBlur.undefined
        ? mainDataErrors
        : Object.keys(mainDataErrors).reduce((accum, key) => {
            if (mainDataBlur[key]) {
              return {
                ...accum,
                [key]: mainDataErrors[key]
              };
            }

            return accum;
          }, {});
    }

    return (
      <MainData
        isChild={false}
        withBirthRegistrationPlace={false}
        data={mainDataValues}
        editableFields={mainDataEditableFields}
        withSnils={false}
        onChange={(data, field) => this.props.changeMainData({ data, field })}
        onBlur={data => this.props.blurMainData(data)}
        valid={mainDataValid}
        onSubmit={() => this.props.submitMainData(true)}
        saveDraft={saveDraft}
        {...props}
      />
    );
  };

  renderPassport = () => {
    const {
      passportValues,
      passportBlur,
      passportErrors,
      mainDataValues: { citizenship, birthdate },
      saveDraft
    } = this.props;
    const props = {};

    if (!passportValues) {
      return false;
    }

    if (passportBlur) {
      props.errors = Object.keys(passportErrors).reduce((accum, key) => {
        if (passportBlur[key]) {
          return {
            ...accum,
            [key]: passportErrors[key]
          };
        }
        return accum;
      }, {});
    }

    const permittedDocuments = getPermittedDocuments(
      'PARENT',
      birthdate,
      CITIZENSHIP_TYPES[citizenship]
    );

    return (
      <React.Fragment key={passportValues.documentType}>
        <div className="StepApplicant__Passport">
          <Passport
            citizenship={CITIZENSHIP_TYPES[citizenship]}
            disabled={this.props.passportDisabled}
            data={passportValues}
            permittedDocuments={permittedDocuments}
            documentType={passportValues.documentType}
            numberMask={numberMask(passportValues.documentType)}
            editableFields={this.props.passportEditableFields}
            onChange={(data, field) =>
              this.props.changePassportData({ data, field })
            }
            onBlur={data => this.props.blurPassportData(data)}
            onDocumentTypeChange={documentType =>
              this.props.changeDocumentType(documentType)
            }
            saveDraft={saveDraft}
            {...props}
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { underFourteen, applicantType } = this.props;

    if (!this.props.stepApplicantTypeComplete) {
      return false;
    }

    const { TYPE } = Message;

    return (
      <>
        {underFourteen && applicantType === APPLICANT_TYPES.parent ? (
          <Message type={TYPE.ERROR} className="StepApplicant__Message">
            <p>
              Родитель (Законный представитель) участника ГИА не может быть
              младше 14 лет.
            </p>
          </Message>
        ) : (
          <div className="StepApplicant ColumnWithInfo">
            <div className="ColumnWithInfo__info">
              <p className="ColumnWithInfo__infoParagraph">
                Данные о заявителе заполняются из личного кабинета.
              </p>
              <p className="ColumnWithInfo__infoParagraph">
                <a
                  className="Link"
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://my.mos.ru/my/#/settings/profile"
                >
                  Отредактируйте профиль
                </a>
                , если вы хотите изменить их.
              </p>
            </div>
            <div className="ColumnWithInfo__main">
              {this.renderMainData()}
              {this.renderPassport()}
            </div>
          </div>
        )}
      </>
    );
  }
}

StepApplicant.propTypes = {
  ...stepApplicantStructuredSelectorPropTypes,
  changeMainData: PropTypes.func.isRequired,
  blurMainData: PropTypes.func.isRequired,
  submitMainData: PropTypes.func.isRequired,
  changePassportData: PropTypes.func.isRequired,
  changeDocumentType: PropTypes.func.isRequired,
  blurPassportData: PropTypes.func.isRequired,
  stepApplicantTypeComplete: PropTypes.bool
};

StepApplicant.defaultProps = {
  stepApplicantTypeComplete: null
};

export default compose(
  connect(stepApplicantStructuredSelector, dispatch =>
    bindActionCreators(
      {
        changeMainData,
        blurMainData,
        changePassportData,
        changeDocumentType,
        blurPassportData,
        submitMainData,
        saveDraft
      },
      dispatch
    )
  )
)(StepApplicant);
